module.exports = __webpack_public_path__ + "static/media/song.089a475d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/song.mp3
// module id = 338
// module chunks = 0